import React, { useMemo } from 'react';

import _, { isEmpty } from 'lodash';

import EmptyMessagePage from '@components/Base/EmptyMessagePage';
import { CustomColumnDef } from '@components/Base/Table/types';
import WorkFlowTable from '@components/Exams/WorkFlowTable';
import { createColumns } from '@components/Exams/WorkFlowTable/columns';
import { Exam } from '@containers/exams/types';
import ClipBoardIcon from 'app/images/clipboard.svg';

import messages from './messages';

interface ExamListProps {
  exams: Exam[];
  isLoading: boolean;
  handleWorkflowClick: (exam: Exam) => void;
}

const ExamList = (props: ExamListProps) => {
  const { exams, isLoading, handleWorkflowClick } = props;

  const renderEmptyPage = isEmpty(exams) && !isLoading;

  const columnsIssued = useMemo(() => {
    return createColumns(handleWorkflowClick).filter((column) => column !== null) as CustomColumnDef<Exam>[];
  }, []);

  return (
    <>
      {renderEmptyPage ? (
        <EmptyMessagePage
          icon={ClipBoardIcon}
          titleMessage={messages.empty_exam}
          descriptionMessage={messages.empty_exam_description}
          descriptionWidth="w-48"
        />
      ) : (
        <div className="flex w-full px-8 py-5">
          <div className="flex flex-col w-full">
            <WorkFlowTable exams={exams} columns={columnsIssued} isLoading={isLoading} />
          </div>
        </div>
      )}
    </>
  );
};

export default ExamList;
